Number.prototype.getMoneyFormat = function (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&.');
};

Number.prototype.getResultFormat = function () {
    return this > 9 ? this : "0" + this;
};
